<template>
  <v-container>
    <div v-if="!user" class="mt-10">
      <h4 class="font-weight-bold title-page primary--text mb-8" tabindex="0">Credores</h4>
      <h4>Por favor, realize o seu login para ter acesso aos dados de Credores.</h4>
    </div>


    <div v-if="user">
      <!-- <v-row class="align-center mt-10">
        <v-col cols="12" sm="6">
          <div class="font-weight-bold title-page primary--text" tabindex="0">Credores</div>
        </v-col>
        

        <v-col cols="12" sm="6" class="d-flex justify-start justify-sm-end mt-2 mt-sm-0">
          <v-btn color="primary" dark @click="addCreditor">
            <v-icon left>mdi-plus</v-icon>
            Adicionar Novo Credor
          </v-btn>
        </v-col>
      </v-row> -->

      <v-row class="mt-10">
        <v-col cols="12">
          <div class="font-weight-bold title-page primary--text" tabindex="0">
            Credores
          </div>
        </v-col>

        <v-col>
          <div v-html="dataset.description" tabindex="0"></div>
        </v-col>

        <v-col cols="12" class="d-flex justify-end mt-0">
          <v-btn color="primary" dark @click="addCreditor">
            <v-icon left>mdi-plus</v-icon>
            Adicionar/Associar Credor
          </v-btn>
        </v-col>
      </v-row>

      <v-divider class="my-10"></v-divider>

      <div class="mt-4" v-if="loading">
        <v-progress-circular indeterminate color="primary" :size="50"></v-progress-circular>
      </div>
      <br />
      <v-row v-if="user && !loading && (!creditors || creditors.length === 0)">
        <v-col>
          <v-alert type="info">
            <span>Você ainda não possui credores associados.</span>
          </v-alert>
        </v-col>
      </v-row>

      <div v-for="(creditorData, i) in creditors" :key="creditorData.id">
        <v-row class="align-center">
          <v-col class="ml-4">
            <div class="d-flex justify-space-between align-center">
              <strong class="mr-4">Credor #{{ i + 1 }}</strong>

              <div class="d-flex align-center">
                <!-- <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn v-if="creditorData.user" v-bind="attrs" v-on="on" type="button" elevation="0" tabindex="0"
                      class="mr-5" aria-label="Botão para visualizar as análises do status do pedido" color="primary"
                      outlined style="height: 25px;" dark @click="creditorHistory(creditorData.user)">
                      <v-icon left>mdi-history</v-icon>
                      Histórico
                    </v-btn>
                  </template>
                <span>Visualizar histórico do credor</span>
                </v-tooltip> -->
                <v-tooltip bottom v-if="creditorData.status !== 3">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn v-bind="attrs" v-on="on" type="button" elevation="0" tabindex="0" class="mr-5"
                      aria-label="Botão para remover o credor" color="important" style="height: 25px;" dark
                      @click="confirmRemoveCreditor(creditorData)">
                      <v-icon left>mdi-trash-can</v-icon>
                      Remover
                    </v-btn>
                  </template>
                  <span>Remover o vínculo com credor</span>
                </v-tooltip>

                <v-tooltip bottom v-if="creditorData.status == 2">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn v-bind="attrs" v-on="on" type="button" elevation="0" tabindex="0" class="mr-5"
                      aria-label="Botão para visualizar as análises do status do pedido" color="primary" outlined
                      style="height: 25px;" dark @click="viewReason(creditorData)">
                      <v-icon left>mdi-text-long</v-icon>
                      Análise
                    </v-btn>
                  </template>
                  <span>Visualizar Análise da Administração Judicial</span>
                </v-tooltip>

                <v-tooltip bottom v-if="creditorData.status == 1 && creditorData.user">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn v-bind="attrs" v-on="on" type="button" elevation="0" tabindex="0" class="mr-5"
                      aria-label="Botão para visualizar as análises do status do pedido" color="primary" outlined
                      style="height: 25px;" dark @click="creditorHistory(creditorData)">
                      <v-icon left>mdi-history</v-icon>
                      Histórico
                    </v-btn>
                  </template>
                  <span>Visualizar histórico do credor</span>
                </v-tooltip>


                <v-chip small label class="font-weight-medium" text-color="white"
                  :color="getStatusClass(creditorData.status)">
                  {{ getStatusText(creditorData.status) }}
                </v-chip>
              </div>
            </div>

            <br />
            <strong>Nome:</strong> {{ creditorData.user.name }}
            <br />
            <strong>CPF/CNPJ:</strong>
            <span> {{ formatRegistration(creditorData.user.registration) }}</span>
            <br />
            <strong>E-mail:</strong>
            <span> {{ creditorData.user.email }}</span>
          </v-col>
          <!-- <v-col>
            <v-row align="center" justify="end" class="mr-1">
              <v-col cols="auto">
                <v-btn v-bind="attrs" v-on="on" id="btnEdit" type="button" elevation="0" tabindex="0"
                  aria-label="Botão para editar os dados do credor" color="primary" style="height: 30px;" dark
                  @click="editCreditor(creditorData)">
                  <v-icon left>mdi-pencil</v-icon>
                  Editar
                </v-btn>
              </v-col>
              <v-col cols="auto">
                <v-btn v-bind="attrs" v-on="on" id="btnDelete" type="button" elevation="0" tabindex="0"
                  aria-label="Botão para remover um credor" color="important" style="height: 30px;" dark
                  @click="confirmRemoveCreditor(creditorData)">
                  <v-icon left>mdi-trash-can</v-icon>
                  Remover
                </v-btn>
              </v-col>
              <v-col cols="auto">
                <v-alert :color="getStatusClass(creditorData.status)" text-color="white" shaped dense dark
                  style="max-width: 200px; height: 35px;">
                  {{ getStatusText(creditorData.status) }}
                </v-alert>
              </v-col>
            </v-row>
          </v-col> -->
        </v-row>

        <v-row>
          <v-col class="ml-4">
            <div class="d-flex align-center">

              <template v-if="!creditorData.document && creditorData.draft_document_url && creditorData.status === 4">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn v-bind="attrs" v-on="on" type="button" elevation="0" color="primary" :loading="loadingDownloadPdf"
                      style="height: 25px; font-weight: bold;" class="mr-2" @click="downloadProcuration(creditorData)">
                      <v-icon left size="16">
                        mdi-file-download
                      </v-icon>
                      Baixar procuração
                    </v-btn>
                  </template>
                  <span>Baixar arquivo pdf do documento de procuração gerado anteriormente</span>
                </v-tooltip>
              </template>

              <template v-if="!creditorData.document_url && creditorData.status === 4">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn v-bind="attrs" v-on="on" outlined color="deep-orange darken-2"
                      style="height: 25px; font-weight: bold;" class="mr-2" @click="updateProcuration(creditorData)">
                      <v-icon left size="16">
                        mdi-file-upload
                      </v-icon>
                      Enviar Procuração
                    </v-btn>
                  </template>
                  <span>Enviar documento de procuração assinado digitalmente</span>
                </v-tooltip>
              </template>

              <template v-else>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <a :href="creditorData.document_url" target="_blank" v-bind="attrs" v-on="on"
                      style="text-decoration: none;">
                      <v-btn outlined color="primary" style="height: 25px;" class="mr-2" v-bind="attrs" v-on="on">
                        <v-icon left size="16">
                          mdi-eye
                        </v-icon>
                        Procuração
                      </v-btn>
                    </a>
                  </template>
                  <span>Visualizar documento de procuração</span>
                </v-tooltip>
              </template>

              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <a :href="creditorData.user.document_url" target="_blank" v-bind="attrs" v-on="on"
                    style="text-decoration: none;">
                    <v-btn v-if="creditorData.status !== 2 && creditorData.status !== 3" outlined color="primary"
                      style="height: 25px;" class="mr-2" v-bind="attrs" v-on="on">
                      <v-icon left size="16">
                        mdi-eye
                      </v-icon>
                      Identificação
                    </v-btn>
                  </a>
                </template>
                <span>Visualizar documento de identificação</span>
              </v-tooltip>

            </div>
          </v-col>
        </v-row>

        <v-row>
          <v-col class="ml-4">
            <div class="d-flex align-center">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-if="[1, 2, 3].includes(Number(creditorData.status))" v-bind="attrs" v-on="on" type="button"
                    elevation="0" tabindex="0" class="mr-5" aria-label="Botão para editar os dados do credor"
                    color="primary" style="height: 25px;" dark @click="creditorData.status === 3
                      ? updateProcuration(creditorData)
                      : editCreditor(creditorData)">
                    
                      <v-icon left>
                        {{ creditorData.status === 3
                          ? 'mdi-file-upload'
                          : 'mdi-pencil' }}
                      </v-icon>

                    {{ creditorData.status === 1
                      ? 'Editar'
                      : 'Enviar novos documentos' }}
                  </v-btn>
                </template>

                <span>
                  {{ creditorData.status === 1
                    ? 'Alterar dados do credor'
                    : 'Enviar novos documentos' }}
                </span>
              </v-tooltip>
            </div>
          </v-col>
        </v-row>


        <!-- <v-row>
          <v-col class="ml-4">
            <div class="d-flex align-center">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-if="creditorData.status === 1" v-bind="attrs" v-on="on" type="button" elevation="0"
                    tabindex="0" class="mr-5" aria-label="Botão para editar os dados do credor" color="primary"
                    style="height: 25px;" dark 
                    @click="creditorData.status === 3 ? updateProcuration(creditorData) : editCreditor(creditorData)">
                    <v-icon left>mdi-pencil</v-icon>
                    {{ creditorData.status === 2 || creditorData.status === 3 ? 'Enviar novos documentos' : 'Editar' }}
                  </v-btn>
                </template>
                <span>{{ creditorData.status === 2 || creditorData.status === 3 ? 'Enviar novos documentos' : 'Alterar dados do credor' }}</span>
              </v-tooltip>
            </div>
          </v-col>
        </v-row> -->

        <v-row
          v-if="creditorData && creditorData.status == 1 && creditorData.user && creditorData.user.userCreditor && creditorData.user.objection_step_approved_amount_at == '0000-00-00 00:00:00'">
          <v-col class="ml-4">
            <div>
              <span tabindex="0">
                Valor <strong>{{(creditorData && creditorData.user && creditorData.user.userCreditor
                  && creditorData.user.userCreditor.amount) || 0 | currency }}</strong>
                incluído na lista de credores.
              </span>

              <div class="mt-1">
                <v-btn text color="primary" class="pa-0 text-decoration-underline" @click="approveAmount(creditorData)">
                  Concordar
                </v-btn>

                <span class="mx-2">/</span>

                <v-btn text color="error" class="pa-0 text-decoration-underline"
                  v-if="$modules.isOpen('site.review.create.lawyer')" @click="$router.push('/revisao-credito/novo')">
                  Discordar
                </v-btn>
              </div>
            </div>
          </v-col>
        </v-row>

        <v-row v-if="creditorData.user.objection_step_approved_amount_at !== '0000-00-00 00:00:00'">
          <v-col>
            <p tabindex="0">
              <v-icon color="accent">mdi-currency-usd</v-icon> Você concordou com o valor de
              <strong>{{ (creditorData.user.userCreditor.amount || 0) | currency }}</strong> no dia
              {{ creditorData.user.objection_step_approved_amount_at | defaultDate('DD/MM/YYYY HH:mm:ss') }}
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" id="btnDiscord" type="button" elevation="0" color="#FFAB40"
                    class="ml-10" small dark @click="revogeApproveAmount(creditorData)" tabindex="0"
                    aria-label="Botão para revogar aprovação de credito">
                    <v-icon left>mdi-restore</v-icon>
                    Revogar Aprovação
                  </v-btn>
                </template>
                <span>Desfazer concordância do valor</span>
              </v-tooltip>
            </p>
          </v-col>
        </v-row>
        <!-- <v-row>
          <v-col class="ml-4">
            <div class="d-flex align-center">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-if="creditorData.user && creditorData.status !== 2 && creditorData.status !== 3" v-bind="attrs" v-on="on" type="button" elevation="0" tabindex="0"
                    class="mr-5" aria-label="Botão para remover o credor" color="important" style="height: 25px;" dark
                    @click="confirmRemoveCreditor(creditorData)">
                    <v-icon left>mdi-trash-can</v-icon>
                    Remover
                  </v-btn>
                </template>
                <span>Remover o vínculo com credor</span>
              </v-tooltip>
            </div>
          </v-col>
        </v-row> -->
        <br />
        <v-divider class="my-4"></v-divider>
      </div>
    </div>

    <!-- MODAL Verificacao de creditos-->
    <v-dialog v-model="creditCheckDialog" width="800px" scrollable>
      <v-card class="pa-3">
        <v-card-title>
          <v-row justify="center">
            <v-col lg="12">
              <h1 class="custom-modal-title text-uppercase primary--text font-weight-bold" tabindex="1">
                VERIFICAÇÃO DE CRÉDITOS - Resumo do credor
              </h1>
              <br>
              <span class="resume-modal-case-name">{{ dataList.modalData.name }}</span>
              <br>
            </v-col>
          </v-row>
        </v-card-title>

        <v-card-text>
          <v-row justify="center" v-if="loadingDialogData">
            <v-col class="text-center">
              <v-progress-circular indeterminate color="primary" size="40" />
            </v-col>
          </v-row>
          <template v-else>
            <v-row v-if="dataset.data && dataset.data.classes && dataset.data.classes.length" no-gutters>
              <v-col>
                <v-row v-for="item in dataset.data.classes" :key="`${item.creditor_type}-${item.currency}`">
                  <v-col class="bordered-item mt-5">
                    <p v-if="dataset.data.classes.length > 1 || item.excluded" class="font-weight-bold mb-4">
                      {{ getCreditorClassName(item.creditor_type) }}
                      <span v-if="item.excluded"> - excluído da Relação de Credores</span>
                    </p>
                    <creditor-phase-history :phases="item.phases" :currency="item.currency"
                      @details="openPhaseDetails" />
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row justify="center" v-else>
              <v-col class="text-center">
                <p class="text-h6 grey--text">Sem registros</p>
              </v-col>
            </v-row>
          </template>
        </v-card-text>

        <v-card-actions>
          <v-btn color="primary darken-1" text @click="creditCheckDialog = false">Fechar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Modal com o texto da análise de uma fase do QGC -->
    <v-dialog v-model="phaseDetailsDialog" max-width="600">
      <v-card>
        <v-card-title class="justify-center text-uppercase font-weight-bold mediumViolet--text"
          style="font-size: 16px; border-bottom: 3px solid #1976D2;">
          Análise
        </v-card-title>
        <v-card-text class="mt-4" tabindex="0">
          <div v-html="phaseDetailsText"></div>
        </v-card-text>
        <v-card-actions class="justify-end">
          <v-btn text class="mediumGray--text" @click="phaseDetailsDialog = false">Fechar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Modal resumo da analise -->
    <v-dialog v-model="showDialog" max-width="600px">
      <v-card class="pa-4">
        <v-card-title class="justify-center text-uppercase font-weight-bold mediumViolet--text"
          style="font-size: 16px; border-bottom: 3px solid #1976D2;">
          Análise
        </v-card-title>

        <v-card-text class="mt-4">
          <div class="mb-4">
            <div class="mt-1 mediumGray--text">
              {{ selectedCreditor && selectedCreditor.reason ? selectedCreditor.reason : 'N/A' }}
            </div>
          </div>
        </v-card-text>

        <v-card-actions class="justify-end">
          <v-btn text class="mediumGray--text" @click="showDialog = false">CANCELAR</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showAddCredor" max-width="800px" persistent>
      <template v-if="showAddCredor">
        <AddCredor @fechar="showAddCredor = false" @new-creditor="recarregarCredores" />
      </template>
    </v-dialog>

    <!-- <v-dialog v-model="showEditCreditorDialog" max-width="800px" persistent>
      <template v-if="showEditCreditorDialog">
        <EditCreditor :creditorId="editingCreditor.id" :creditorUserId="editingCreditor.user_id"
          @fechar="showEditCreditorDialog = false" @creditor-updated="recarregarCredores" />
      </template>
    </v-dialog> -->

    <v-dialog v-model="showMessageProcurationDialog" max-width="600px">
      <v-card>
        <v-card-title class="headline justify-center text-center">
          Atenção
        </v-card-title>
        <v-divider></v-divider>
        <br>
        <v-card-text>
          Após gerar o texto do <strong>documento de procuração</strong>, revisar se os dados estão corretos,
          tanto do <strong>credor</strong> quanto do <strong>procurador</strong>, gerar o documento em formato PDF.
          <br>
          <br>
          O credor deverá assinar digitalmente o documento de procuração, por meio da plataforma
          <strong>Gov.br</strong>.
          <br>
          <br>
          Utilizar o botão <strong>ENVIAR PROCURAÇÃO</strong> que esta la listagem de credores, para enviar o arquivo
          pdf que foi assinado, contendo a procuração.
          <br>
          <br>
          A validação do vínculo será realizada de forma <strong>automática</strong> e imediata
          no momento do envio da procuração. Para credores empresa, haverá uma etapa adicional de análise, de forma
          manual.
          <br>
          <br>
          Nota: a assinatura digital deve ser aplicada ao último arquivo PDF gerado pela plataforma, e esse arquivo deve
          ser retornado ao sistema.
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="confirmAddCreditor">
            Entendi
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showUpdateProcurationDialog" max-width="600px">
      <v-card>
        <v-card-title class="font-weight-bold primary--text justify-space-between mb-4">
          Enviar procuração
        </v-card-title>
        <v-card-text>
          <v-form>
            <v-row>
              <v-col>
                <v-file-input dense accept="application/pdf" prepend-icon="" outlined counter required
                  :rules="[$rules.fileSize(4)]" show-size truncate-length="50"
                  hint="O arquivo não pode ser superior a 4MB" hide-details="auto" label="Documento procuração"
                  :clearable="true" v-model="dataset.procuration_file" @change="onProcurationFileChange"
                  ref="procuration_file" />
              </v-col>
            </v-row>

            <br>
            <v-btn color="primary" type="submit" @click="updateProcurationFile" :loading="loadingPdf">Enviar</v-btn>
            <v-btn text class="grey--text" @click="showUpdateProcurationDialog = false">Cancelar</v-btn>

          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-snackbar v-model="showErrorSnackbar" color="error" :timeout="3000">
      {{ errorMessage }}
      <template v-slot:action="{ attrs }">
        <v-btn color="white" text v-bind="attrs" @click="showErrorSnackbar = false">
          Fechar
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
import AddCredor from './AddCreditor.vue';
import CreditorPhaseHistory from '@/components/creditor/CreditorPhaseHistory.vue';
//import EditCreditor from './EditCreditor.vue';
import axios from 'axios';

export default {
  components: {
    AddCredor,
    CreditorPhaseHistory,
   // EditCreditor
  },
  data() {
    return {
      user: null,
      creditors: [],
      validForm: false,
      showDialog: false,
      showAddCredor: false,
      loadingPdf: false,
      loadingDownloadPdf: false,
      showUpdateProcurationDialog: false,
      showEditCreditorDialog: false,
      showMessageProcurationDialog: false,
      editingCreditorId: null,
      editingCreditor: null,
      selectedCreditor: null,
      showErrorSnackbar: false,
      errorMessage: '',
      creditCheckDialog: false,
      loadingDialogData: false,
      phaseDetailsDialog: false,
      phaseDetailsText: '',
      dataList: {
        modalData: {},
      },
      dataset: {
        description: '',
        data: [],
        userRequestedValue: 0,
      },
      loading: false,

    };
  },
  created() {
    if (this.$root.user) {
      this.user = this.$root.user;
      this.fetchLawyerCreditors();
      this.loadText();
    }
  },
  methods: {

    async fetchLawyerCreditors() {
      this.loading = true;
      try {
        const response = await axios.get('/api/lawyers/associated-users', {
          // params: { idProcurador: this.user.id }
        });
        console.log("Dados dos credores recebidos:", response.data.content.data);
        this.creditors = response.data.content.data;
      } catch (error) {
        console.error("Erro ao buscar credores:", error);
        this.errorMessage = "Erro ao carregar os credores. Por favor, tente novamente mais tarde.";
        this.showErrorSnackbar = true;
      } finally {
        this.loading = false;
      }

    },

    async loadText() {
      try {
        const result = await axios.get(`/api/dynamic-infos/keys`, {
          params: { keys: 'lawyer-creditor-add-description' }
        })

        this.dataset.description = result.data.content && result.data.content.length > 0 ? result.data.content[0].value : '';

      } catch (error) {
        this.$dialog.notify.error(this.$codes(error), {
          position: 'top-right',
          timeout: 2000
        })
      }
    },

    async addCreditor() {
      this.showMessageProcurationDialog = true;
    },

    confirmAddCreditor() {
      this.showMessageProcurationDialog = false;
      this.showAddCredor = true;
    },

    addNewCreditor(newCreditor) {
      this.showAddCredor = false;
      this.creditors.push(newCreditor);
      this.recarregarCredores();
    },

    recarregarCredores() {
      this.fetchLawyerCreditors();
    },

    editCreditor(creditor) {

      this.$router.push({
        name: 'lawyerUserEdit',
        params: {
          id: creditor.user_id
        }
      });

      //this.$router.push({ name: 'edit-creditor', params: { id: creditor } });
    
      ////this.editingCreditor = creditor;
      ////this.showEditCreditorDialog = true; // Abre o diálogo de edição
      ////console.log('Editar credor com ID:', this.editingCreditor);
    },

    onProcurationFileChange(file) {
      this.dataset.procuration_file  = file;
    },

    updateProcuration(data){
      console.log("Dados credor: ", data)
      this.dataset.creditorRegistration = data.user.registration
      this.dataset.record_id = data.id
      this.dataset.creditorId = data.user_id
      this.showUpdateProcurationDialog = true;
    },

    async updateProcurationFile(){

      if(!this.dataset.procuration_file){
        this.$dialog.notify.error('Por favor, selecione o arquivo da procuração assinada antes de enviar.')
        return;
      }

      const isCompany = this.dataset.creditorRegistration.replace(/\D/g, "").length === 14;

      const isExecutor = this.user.is_executor === 1

      const formData = new FormData();
      formData.append("signed_pdf", this.dataset.procuration_file);
      formData.append("id", this.dataset.record_id);
      formData.append("userId", this.dataset.creditorId); 

      this.loadingPdf = true;
      let uploadSucceeded = false;
      
      try {
      
        const response = await axios.post('/api/lawyers/upload-template-pdf', formData)
        const updatedAssociation = response.data && response.data.content && response.data.content.association

        if (updatedAssociation) {
          const creditorIndex = this.creditors.findIndex((creditor) => creditor.id === updatedAssociation.id)

          if (creditorIndex > -1) {
            this.creditors.splice(creditorIndex, 1, {
              ...this.creditors[creditorIndex],
              document: updatedAssociation.document,
              document_url: updatedAssociation.document_url,
              status: updatedAssociation.status,
            })
          }
        }

        let successMessage = "";

        const baseCompanyMessage = `
          Agora, os Administradores Judiciais procederão à avaliação dos demais documentos necessários 
          para a adequada representação processual. Após, você receberá a confirmação sobre o cadastramento, 
          ou eventual pedido de complementação documental.
        `;

        if (isCompany || isExecutor) {
          successMessage = `
            ${!isExecutor ? 'Sua assinatura foi considerada válida!<br><br>' : ''}
            ${baseCompanyMessage}
          `;
        } else {
          successMessage = `
            Procuração enviado e validada com sucesso!<br><br>
            PRONTO! Agora você poderá solicitar a revisão de seu crédito e/ou aderir ao Plano de Recuperação Judicial.
          `;
        }

        await this.$dialog.confirm({
          html: true,
          text: successMessage,
          title: '✔️ Sucesso',
          actions: {
            true: 'OK'
          }
        });

        uploadSucceeded = true;
        
      } catch (error) {
        console.error("Erro ao enviar PDF:", error)

        let apiMessage = 'Erro desconhecido ao enviar o PDF.'

        if (
          error &&
          error.response &&
          error.response.data &&
          error.response.data.content &&
          error.response.data.content.error &&
          error.response.data.content.error.message
        ) {
          apiMessage = error.response.data.content.error.message
        } else if (error && error.message) {
          apiMessage = error.message;
        }
          apiMessage = this.formatProcurationUploadError(apiMessage)
          //this.$dialog.notify.error(apiMessage)
          await this.$dialog.confirm({
            html: true,
            text: apiMessage, 
            title: '❌ Erro!',
            actions: {
              true: 'OK'
            }
          });
        return { error: true, message: apiMessage }
      }finally {
        this.loadingPdf = false;
        if (uploadSucceeded) {
          this.showUpdateProcurationDialog = false;
          this.dataset.procuration_file = null;
          this.recarregarCredores();
        }
      }
    },

    formatProcurationUploadError(message) {
      const safeMessage = message || 'Erro desconhecido ao enviar o PDF.'
      return `
        <strong>Não foi possível validar a procuração enviada.</strong><br><br>
        ${safeMessage}
      `
    },

    confirmRemoveCreditor(creditor) {
      this.$dialog.confirm({
        title: 'Remover Credor',
        text: `Tem certeza que deseja remover o credor <strong>${creditor.user.name}</strong>? <br> <br>Esta ação é irreversível!`,
        persistent: true,
        actions: {
          false: 'Cancelar',
          true: 'Remover'
        }
      }).then((result) => {
        if (result) {
          this.removeCreditor(creditor.id, creditor.user_id);
        }
      });
    },

    async removeCreditor(id, creditorId) {
      this.loading = true;
      try {
        
        const response = await axios.delete(`/api/lawyers/associated-user`, {
          params: {
              id: id,
              userId: creditorId
            }
        });
        
        this.$dialog.notify.success("Credor removido com sucesso!", { position: 'top-right', timeout: 5000 });
        
        this.recarregarCredores();
      } catch (error) {
        const hasResponse = error && error.response && error.response.data;

          if (hasResponse) {

            const apiMessage =
              error.response &&
              error.response.data &&
              error.response.data.content &&
              error.response.data.content.error &&
              error.response.data.content.error.message;

            this.$dialog.notify.error(
              apiMessage || "Erro ao remover o credor!",
              {
                position: "top-right",
                timeout: 5000,
              }
            );
          }
      } finally {
        this.loading = false;
      }
    },

    formatCpf(value) {
      if (!value) return '';
      return value.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})$/, "$1.$2.$3-$4");
    },

    formatCnpj(value) {
      if (!value) return '';
      return value.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, "$1.$2.$3/$4-$5");
    },

    formatRegistration(value) {
      if (!value) return '';
      return value.length <= 11 ? this.formatCpf(value) : this.formatCnpj(value);
    },

    viewReason(item) {
      this.selectedCreditor = item;
      this.showDialog = true;
    },

    getStatusClass(status) {
      switch (status) {
        case 0:
          return "warning";
        case 1:
          return "green";
        case 2:
          return "error";
        case 3:
          return "blue-grey";
        case 4:
          return "deep-orange";
        default:
          return "grey";
      }
    },

    getStatusText(status) {
      switch (status) {
        case 0:
          return "Aguardando análise";
        case 1:
          return "Aprovado";
        case 2:
          return "Rejeitado";
        case 3:
          return "Removido";
        case 4:
          return "Aguardando procuração";
        default:
          return "Desconhecido";
      }
    },

    formatCurrencyValue(value, currency) {

      console.log("Dados: ", value, currency)

      if (value === null || value === undefined) {
        return 'N/A';
      }

      let options = {
        style: 'currency',
        currency: 'BRL' // Default
      };

      switch (currency) {
        case 1:
          options.currency = 'BRL';
          break;
        case 2:
          options.currency = 'USD';
          break;
        case 3:
          options.currency = 'EUR';
          break;
        default:
          options.currency = 'BRL';
      }

      return new Intl.NumberFormat('pt-BR', options).format(value);
    },

    getCreditorClassName(type) {
      const classes = {
        1: 'Classe I - Trabalhista',
        2: 'Classe II - Garantia Real',
        3: 'Classe III - Quirografários',
        4: 'Classe IV - ME/EPP',
        5: 'Extraconcursais',
      };

      return classes[type] || 'Classe não informada';
    },

    openPhaseDetails(details) {
      this.phaseDetailsText = details;
      this.phaseDetailsDialog = true;
    },

    async creditorHistory(creditorData) {

      this.dataset.data = null
      this.dataList.modalData = { name: creditorData.user.name }
      this.creditCheckDialog = true;
      this.loadingDialogData = true;

      try {
        const result = await axios.get('/api/lawyers/creditor-qgc-history', { params: { creditor_id: creditorData.user_id } })

        if (result && result.data && result.data.content && result.data.content.data) {
          this.dataset.data = result.data.content.data;
        }

      } catch (error) {
        this.$dialog.notify.error(this.$codes(error), {
          position: 'top-right',
          timeout: 2000
        })
      } finally {
        this.loadingDialogData = false;
      }

    },

    async approveAmount(creditorData) {
      if (this.$moduleBlocked('site.review.agree_amount')) return;
      const creditorId = creditorData.user_id;
      const valueToApprove = creditorData.user.userCreditor.amount;

      if (!creditorId) {
        this.$dialog.notify.error("ID do credor não encontrado para aprovação.", { position: 'top-right', timeout: 5000 });
        return;
      }

      
      const result = await this.$dialog.confirm({
        text: `Deseja concordar com o valor de <strong>${this.formatCurrencyValue(valueToApprove, 1)}</strong>?`,
        title: 'Concordar com valor',
        actions: {
          false: 'Cancelar',
          true: 'Concordar'
        }
      });

      if (!result) return;

      this.loading = true;

      try {
        const response = await axios.post(`/api/lawyers/objection-amount/${creditorId}`, {
          value: valueToApprove
        });

        this.$dialog.notify.success("Valor aprovado com sucesso!", { position: 'top-right', timeout: 5000 });

        this.recarregarCredores();

      } catch (error) {

        let apiMessage = 'Erro desconhecido ao enviar o PDF.'

        if (
          error &&
          error.response &&
          error.response.data &&
          error.response.data.content &&
          error.response.data.content.error &&
          error.response.data.content.error.message
        ) {
          apiMessage = error.response.data.content.error.message
        } else if (error && error.message) {
          apiMessage = error.message;
        }
          await this.$dialog.confirm({
            text: apiMessage, 
            title: '❌ Erro!',
            actions: {
              true: 'OK'
            }
          });
        return { error: true, message: apiMessage }
  } finally {
    this.loading = false;
  }
    },

    async revogeApproveAmount(creditorData) { 
      if (this.$moduleBlocked('site.review.agree_amount')) return;
      const creditorId = creditorData.user_id; 
      const valueToApprove = creditorData.user.userCreditor.amount;

      if (!creditorId) {
        this.$dialog.notify.error("ID do credor não encontrado para revogação.", 
          { position: 'top-right', timeout: 5000 });
        return;
      }

      try {
    const result = await this.$dialog.confirm({
      text: `Deseja revogar o valor aprovado anteriormente de <strong>${this.formatCurrencyValue(valueToApprove, 1)}</strong>?`,
      title: 'Revogar aprovação',
      actions: {
        false: 'Cancelar',
        true: 'Revogar' 
      }
    });
        if (!result) { 
          return; 
        }
      } catch (error) {
        return; 
      }

      this.loading = true; 

      try {
        const response = await axios.delete(`/api/lawyers/objection-amount/${creditorId}`, {
          value: valueToApprove
        });

        this.$dialog.notify.success("Valor revogado com sucesso!", { position: 'top-right', timeout: 5000 });
        this.recarregarCredores();
      } catch (error) {
        console.error("Erro ao revogar:", error);
        if (error.response && error.response.data && error.response.data.message) {
          this.$dialog.notify.error(error.response.data.message, { position: 'top-right', timeout: 5000 });
        } else {
          this.$dialog.notify.error("Erro ao revogar o valor. Por favor, tente novamente.", { position: 'top-right', timeout: 5000 });
        }
      } finally {
        this.loading = false;
      }
    },

    async downloadProcuration(creditorData) {
      this.loadingDownloadPdf = true;
      let downloaded = false;
      const fileName = "procuracao.pdf";

      try {
        if (!creditorData || !creditorData.id) {
          throw new Error("Registro da associação não encontrado");
        }

        const response = await axios.get(
          "/api/lawyers/associated-user-draft",
          {
            params: {
              id: creditorData.id
            }
          }
        );

        if (
          !response.data ||
          !response.data.content ||
          !response.data.content.url
        ) {
          this.$dialog.notify.error(
            "Erro ao obter o arquivo de procuração!",
            { position: "top-right", timeout: 3000 }
          );
          return;
        }

        const link = document.createElement("a");
        link.href = response.data.content.url;
        link.download = fileName;

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        downloaded = true;
      } catch (error) {
        console.error("Erro ao obter ou baixar a procuração:", error);
        this.$dialog.notify.error(
          "Erro ao baixar o arquivo!",
          { position: "top-right", timeout: 5000 }
        );
      } finally {
        this.loadingDownloadPdf = false;
      }

      if (!downloaded) return;

      await this.$dialog.confirm({
        title: "Download Procuração",
        text:
          'O arquivo "' + fileName + '" foi baixado! <br> <br>' +
          "Por padrão, o arquivo é salvo na pasta <strong>Downloads</strong> ou na pasta configurada como padrão no seu navegador.",
        actions: {
          true: {
            text: "Ok",
            color: "primary"
          }
        },
        html: true
      });
    },


  }
};
</script>
